export default {
	seo_meta_title_leaguepass: 'NBA | NBA影片和集錦',
	seo_meta_desc_leaguepass: 'NBA視訊重點介紹NBA影片和集錦',
	seo_meta_keywords_leaguepass: 'NBA視訊，NBA集錦，籃球影片，最佳球賽，扣籃，特輯',
	seo_meta_title_featured: 'NBA | 精選',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV 直播',
	seo_meta_desc_nbatv: 'NBA TV直播每週為您提供全天24小時的NBA比賽直播和存檔影片、演播室節目及分析師報導的NBA TV頻道串流服務',
	seo_meta_keywords_nbatv: 'NBA TV，節拍，經典球衣，NBA直播，真實NBA，NBA比賽時間，內幕花絮，演播室節目，跳躍',
	seo_meta_title_classicgames: 'NBA | 經典賽事',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | 影片清單',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | NBA TV 節目',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'NBA | 主頁',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | 所有頻道',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | 頻道',
	seo_meta_pre_title_categories: 'NBA | 各種類別',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | 類別',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | 影片',
	seo_meta_pre_title_event: 'NBA | 活動',
	seo_meta_title_events: 'NBA | 活動',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | 活動：{0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | 搜尋',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | 網頁不存在',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'NBA | 比賽',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | NBA 影片及賽事精華',
	seo_meta_desc_video: 'NBA視訊重點介紹NBA影片和集錦',
	seo_meta_keywords_video: 'NBA視訊，NBA集錦，籃球影片，最佳球賽，扣籃，特輯',
	seo_meta_title_channel: 'NBA | NBA TV 直播',
	seo_meta_desc_channel: 'NBA TV直播每週為您提供全天24小時的NBA比賽直播和存檔影片、演播室節目及分析師報導的NBA TV頻道串流服務',
	seo_meta_keywords_channel: 'NBA TV，節拍，經典球衣，NBA直播，真實NBA，NBA比賽時間，內幕花絮，演播室節目，跳躍',
	seo_meta_title_tvguide: 'NBA | NBA TV 直播時間表',
	seo_meta_desc_tvguide: 'NBA TV直播每週為您提供全天24小時的NBA比賽直播和存檔影片、演播室節目及分析師報導的NBA TV頻道串流服務',
	seo_meta_keywords_tvguide: 'NBA TV，節拍，經典球衣，NBA直播，真實NBA，NBA比賽時間，內幕花絮，演播室節目，跳躍',
	timezone: '東部時間',
	default_feed_error_message: '出現錯誤，現無法提供此內容。請於稍後再試。',
	watch_in_app: '在 NBA 應用程式上觀賞球賽',
	no_content: '目前沒有內容可觀看',
	see_more: '查看更多',
	now_playing: '現正播放',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'LEAGUE PASS',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: '您最喜歡的視訊數量已達上限。請在添加更多視訊前先移除一部分。',
	item_live: '現場直播',
	add_favourite_title: '加入至我的喜愛',
	remove_favourite_title: '從我的喜愛中移除',
	p_channel_live: '現場直播',
	p_channel_schedule_title: 'NBA TV 時間表',
	p_channel_schedule_watch: '收看',
	p_channel_schedule_no_date: '目前沒有適用的賽程日期。',
	p_channel_live24x7_title: 'NBA TV 每日 24 小時全天候無間直播',
	p_channel_live24x7_see_full_schedule: '查看完整的時間表',
	p_channel_live24x7_up_next: '下一頁',
	p_channel_live24x7_on_demand: 'NBA TV：點播重溫',
	p_channel_live24x7_collection: '我的收藏',
	p_channel_live24x7_demand_1_logo_text: '原創節目',
	p_channel_live24x7_demand_1_show_name: 'NBA TV 節目',
	p_channel_live24x7_demand_1_show_desc: '原創 NBA TV 節目包括「Shaqtin\' a Fool」、「Beyond the Paint」、「Game Time」以及「Basketball Stories」',
	p_channel_live24x7_demand_2_logo_text: '經典賽事',
	p_channel_live24x7_demand_2_show_name: 'NBA 經典賽事',
	p_channel_live24x7_demand_2_show_desc: '觀賞整場經典賽事，包括自 2000 年以來的所有總決賽對碰、聯盟歷史時刻及傳奇球員特輯',
	p_channel_clips_title: 'NBA TV 短片',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: '賽程表',
	p_nba_tv_shows: 'NBA TV 節目',
	p_nba_tv_no_access_title: '24/7 NBA：緊貼賽事分析、直播室評述員分析、原創節目及更多精彩內容！',
	p_nba_tv_no_access_desc: '觀賞直播賽事，以及點播重溫經典賽事和其他節目。',
	p_nba_tv_no_access_note: '播出或會受到限制',
	tv_show_item_latest_episode: '最新一集',
	tv_show_item_no_latest_episode: '沒有最新一集',
	see_all: '查看全部',
	header_menu_watch: '收看',
	header_menu_featured: '精選',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: '球員',
	videos: '影片',
	teams: '球隊',
	most_searched: '最多人搜尋',
	no_result: '沒有數據',
	search_filter_type_most_relevant: '最相關',
	search_filter_type_most_viewed: '最多人觀看',
	search_filter_type_most_recent: '最近期',
	search_filter_type_last_30_days: '最近 30 天',
	search_filter_type_last_6_months: '最近 6 個月',
	search_result_label: '“{keyword}” 的搜尋結果',
	search_result_info: '查看 {keyword} 的所有搜尋結果',
	search_placeholder: '搜尋影片庫',
	load_more: '下載更多',
	button_subscribe: '訂閱',
	button_sign_in: '登入',
	p_league_pass_no_access_title: '在您的電腦、智能手機及電視等任何裝置上觀賞直播賽事或點播重溫賽事！',
	p_league_pass_no_access_desc: 'NBA League Pass 帶您現場直擊精彩動態：您可選擇觀看整個聯盟的所有賽事、只觀看你喜愛球隊的賽事或收看單場賽事，立即查看更多賽事選項。',
	p_league_pass_no_access_note: '受條款限制',
	category_title: '視訊',
	p_video_playlist_title: '播放列表',
	p_no_access_league_pass_title: '啟動 NBA League Pass 並開始觀看：',
	p_no_access_league_pass_desc: 'NBA League Pass 帶您現場直擊精彩動態：您可選擇觀看整個聯盟的所有賽事、只觀看你喜愛球隊的賽事或收看單場賽事，立即查看更多賽事選項。',
	p_no_access_league_pass_terms: '受條款限制',
	p_no_access_league_pass_geo_desc: '根據您目前的所在地區，您無法透過 NBA League Pass 和 NBA TV 觀看這場賽事。NBA League Pass 用戶可於賽事播放後三天重溫這場已存檔的賽事。請諮詢您當地電視台和電台廣播商的時間表，以瞭解您所在地區的廣播詳情。',
	p_no_access_league_pass_not_found_desc: '很抱歉，找不到您查詢的影片。',
	p_no_access_event_not_found_desc: '很抱歉，找不到您查詢的活動。',
	p_no_access_nba_tv_title: '啟動 NBA League Pass 並開始觀看：',
	p_no_access_nba_tv_desc: '觀賞直播賽事及點播重溫經典賽事及其他節目。',
	p_no_access_nba_tv_terms: '受條款限制',
	p_no_access_nba_tv_geo_desc: '根據您目前的所在地區，您無法透過 NBA League Pass 和 NBA TV 觀看這場賽事。NBA League Pass 用戶可於賽事播放後 3 天重溫這場已存檔的賽事。請諮詢您當地電視台和電台廣播商的時間表，以瞭解您所在地區的廣播詳情。',
	p_no_access_nba_tv_not_found_desc: '很抱歉，找不到您查詢的頻道。',
	p_no_access_up_next: '下一頁',
	p_video_completed_title: '播放列表完成',
	p_video_completed_desc: '返回並瀏覽或查看您的下一個播放列表',
	p_video_share_to: '分享給：',
	p_video_more_to_watch: '更多精彩內容：',
	p_event_section_title: '節目',
	p_event_playlist_title: '播放列表',
	p_event_button_watch: '收看',
	p_event_button_listen: '收聽',
	p_event_button_ticket: '門票',
	notfound: '抱歉，找不到您查詢的頁面。',
	notfound_desc: '請檢查 URL 是否有誤。 <br/> 您亦可以嘗試使用網站導覽或搜尋工具來尋找您想觀看的內容。',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: '您的 NBA League Pass 帳戶已達到串流上限。請點擊「繼續」在本裝置繼續收看。',
	modal_pcm_custom: '繼續',
	modal_pcm_close: '取消',
	modal_adobe_concurrency_header_title: '影片連線中斷',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: '您的串流已關閉。有可能因為同步串流經已達到上限、網絡中斷或遇上其他技術問題。請重新登入，並選擇頻道繼續觀看。',
	modal_adobe_concurrency_close: '完成',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: '這部影片無法在您的裝置上播放。點擊 <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'> 這裡 </a> 獲得更多協助。',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: '確認',
	freesample_notice_time: '剩餘時間',
	freesample_notice_title: '享受你的 {0} 分鐘權限',
	freesample_notice_desc: '訂閱完整的 League Pass 套餐，在 {0} 分鐘結束後繼續存取內容。',
	freesample_notice_subscribe_button: '訂閱',
	freesample_notice_cancel_button: '隨時取消',
	freesample_popup_title: '你的權限已結束',
	freesample_popup_subtitle: '訂閱 League Pass，觀看更多 NBA 精彩內容。',
	freesample_popup_link: '瞭解更多',
	freesample_popup_get_minutes_button: '取得 {0} 分鐘',
	reg_required_desc: '您必須先登入才能查看此內容',
	favorite_teams_title: '最喜愛球隊',
	bookmarked_title: '已儲存',
	watch_history_title: '繼續觀看',
	game_schedule_title: '比賽日程表',
	recommended_title: '推薦',
	season_text: '賽季',
	section_tv_provider_title: '我的電視節目供應商',
	section_tv_provider_desc: '透過您的電視節目供應商觀看直播賽事及串流。',
	section_tv_provider_faq: '電視節目供應商常見問題',
	section_tv_provider_sign_out: '登出',
	header_menu_account_my_account: '我的帳戶',
	header_menu_account_manage_account: '管理帳戶',
	header_menu_account_favorite_teams: '最喜歡的球隊',
	header_menu_account_favorite_players: '最喜歡的球員',
	header_menu_account_viewing_history: '收看記錄',
};
